/**
 * 
 * import 할거없는 단순 함수
 * 
 */

import { endOfMonth, format, startOfMonth } from "date-fns";

const calculateRemToPx = (rem) => {
    const fontSize = getComputedStyle(document.documentElement).fontSize;
    return rem * parseFloat(fontSize);
};

export { calculateRemToPx };

// =====================================
// 시간 계산하기
// =====================================

const addTimeStrings = (time1, time2) => {
    const [h1, m1, s1] = time1.split(':').map(Number);
    const [h2, m2, s2] = time2.split(':').map(Number);
    
    let totalSeconds = (h1 * 3600 + m1 * 60 + s1) + (h2 * 3600 + m2 * 60 + s2);
    
    const hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${hours}:${minutes}:${seconds}`;
};

// 시간 문자열을 빼는 함수
const subtractTimeStrings = (time1, time2) => {
    const [h1, m1, s1] = time1.split(':').map(Number);
    const [h2, m2, s2] = time2.split(':').map(Number);
    
    let totalSeconds1 = h1 * 3600 + m1 * 60 + s1;
    let totalSeconds2 = h2 * 3600 + m2 * 60 + s2;

    let diffSeconds = totalSeconds1 - totalSeconds2;

    if (diffSeconds < 0) {
        return "00:00:00"; // 음수일 경우 0으로 처리
    }

    const hours = Math.floor(diffSeconds / 3600);
    diffSeconds %= 3600;
    const minutes = Math.floor(diffSeconds / 60);
    const seconds = diffSeconds % 60;

    return `${hours}:${minutes}:${seconds}`;
}

export { addTimeStrings, subtractTimeStrings };

const getMonthStrEndDateList = (date) => {
    // 오늘 날짜의 월을 'yyyy-MM' 형식으로 포맷
    const dateMonth = format(date, 'yyyy-MM');

    // 월의 시작일 구하기
    const startOfCurrentMonth = startOfMonth(date);

    // 월의 마지막일 구하기
    const endOfCurrentMonth = endOfMonth(date);

    // console.log(`월의 시작일: ${startOfCurrentMonth}`);
    // console.log(`월의 마지막일: ${endOfCurrentMonth}`);
    return { dateMonth, startOfCurrentMonth, endOfCurrentMonth };
}

export { getMonthStrEndDateList };


const convertTimeStringToDate = (timeString) => {
    if (!timeString){
        const date = new Date();
        date.setHours(0, 0, 0, 0);
        return date;
    } ;
    const [hours, minutes, seconds] = timeString.split(':');
    const date = new Date();
    date.setHours(parseInt(hours, 10));
    date.setMinutes(parseInt(minutes, 10));
    date.setSeconds(parseInt(0, 10));
    return date;
};

export { convertTimeStringToDate };

const convertTimeStringToTime = (timeString) => {
    if (!timeString){
        return "0:0";
    }
    timeString.replace(/(\d+)\s*시간\s*(\d+)\s*분/, '$1:$2');
    return timeString;
}

export { convertTimeStringToTime };

